import React from 'react';
import { pure } from '@dbk/ui-react-utils';

import ChartHeader from '../../positions/chart-header';

function CashChartHeader(props) {
  return (
    <ChartHeader
      valueLabel="Account balance"
      priceDateLabel="Balance Date"
      dayChangeLabel="Balance Day Change"
      {...props}
    />
  );
}

CashChartHeader.propTypes = ChartHeader.propTypes;

export default pure(CashChartHeader);
